// import { Toll } from '@mui/icons-material';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell, ResponsiveContainer, LabelList } from 'recharts';

// const processChartData = (data) => {
//   // Calculate total percentage
//   const totalPercentage = data.reduce((sum, item) => sum + item.value, 0);
  
//   // If total is more than 100%, create 'Others' category
//   if (totalPercentage > 100) {
//     const sortedData = [...data].sort((a, b) => b.value - a.value);
//     const topCategories = sortedData.slice(0, -1);
//     const topCategoriesSum = topCategories.reduce((sum, item) => sum + item.value, 0);
//     const othersValue = 100 - topCategoriesSum;
    
//     return [
//       ...topCategories,
//       { 
//         label: 'Others', 
//         value: othersValue 
//       }
//     ];
//   }
  
//   // If total is less than 100%, add 'Others' category
//   if (totalPercentage < 100) {
//     return [
//       ...data,
//       { 
//         label: 'Others', 
//         value: 100 - totalPercentage 
//       }
//     ];
//   }
  
//   return data;
// };

// const CustomLabel = ({ x, y, width, value, label }) => {
//   return (
//     <>
//       {/* Category label above bar */}
//       <text
//         x={x}
//         y={y - 5}
//         textAnchor="start"
//         fill="#FFFFFF99"
//         fontSize="12px"
//       >
//         {label}
//       </text>
//       {/* Percentage label in middle of bar */}
//       <text
//         x={x + width / 2}
//         y={y + 15}
//         textAnchor="middle"
//         fill="#FFFFFF"
//         fontSize="12px"
//       >
//         {`${value.toFixed(0)}%`}
//       </text>
//     </>
//   );
// };

// export const PieChartComponent = ({ data }) => {
//   const processedData = processChartData(data);
  
//   return (
//     <div>
//       <BarChart
//         width={400}
//         height={processedData.length * 50 }
//         data={processedData}
//         layout="vertical"
//         margin={{ top: 10, right: 100, left: 10, bottom: 10 }}
//       >
//         <XAxis type="number" hide />
//         <YAxis type="category" hide dataKey="label" />
//         <Bar
//           dataKey="value"
//           fill="url(#barGradient)"
//           barSize={30}
//           // minPointSize={2}
//             radius={[0, 6, 6, 0]}
//   cursor="pointer"
//           // label={<CustomLabel />}
//           onMouseOver={(data, index) => {
//             // Preventing default hover behavior
//             return null;
//           }}
//         >
//           {processedData.map((entry, index) => (
//             <Cell 
//               key={`cell-${index}`}
//               style={{ cursor: 'default' }}
//             />
//           ))}
//             <LabelList
//               dataKey="value"
//               position="center"
//               formatter={(value) => `${value}%`}
//               style={{ fill: "white", fontSize: "0.6rem" }}
//             />
//               <LabelList
//                 dataKey="label"
//                 position="right"
//                 // formatter={(value) => formatPercentage(value)}
//                 style={{ fill: "white", fontSize: "0.7rem",fontStyle:'Roboto' }}
//               />
//         </Bar>
//         <defs>
//           <linearGradient id="barGradient" x1="0" y1="0" x2="1" y2="0">
//             <stop offset="0%" stopColor="#BF6FE5" />
//             <stop offset="100%" stopColor="#CA698F" />
//           </linearGradient>
//         </defs>
//       </BarChart>
//     </div>
//   );
// };


import { Toll } from '@mui/icons-material';
import { BarChart, Bar, XAxis, YAxis, Cell, ResponsiveContainer, LabelList } from 'recharts';

const processChartData = (data) => {
  // Calculate total percentage
  const totalPercentage = data.reduce((sum, item) => sum + item.value, 0);
  
  // If total is more than 100%, create 'Others' category with remaining items
  if (totalPercentage > 100) {
    const sortedData = [...data].sort((a, b) => b.value - a.value);
    let runningSum = 0;
    let cutoffIndex = 0;
    
    // Find how many items we can include before exceeding 100%
    for (let i = 0; i < sortedData.length; i++) {
      if (runningSum + sortedData[i].value <= 100) {
        runningSum += sortedData[i].value;
        cutoffIndex = i;
      } else {
        break;
      }
    }
    
    // Keep items that fit within 100%
    const keptItems = sortedData.slice(0, cutoffIndex + 1);
    
    // If we've used exactly 100%, no need for Others category
    if (runningSum === 100) {
      return keptItems;
    }
    
    // Create Others category with remaining percentage
    return [
      ...keptItems,
      {
        label: 'Others',
        value: 100 - runningSum
      }
    ];
  }
  
  // If total is less than 100%, add 'Others' category
  if (totalPercentage < 100) {
    return [
      ...data,
      { 
        label: 'Others', 
        value: 100 - totalPercentage 
      }
    ];
  }
  
  return data;
};

// Colors for different segments
const COLORS = [
 '#BF6FE5', '#CA698F', '#E57373', '#FFB74D', '#81C784', 
 '#64B5F6', '#9575CD', '#4DB6AC', '#FFF176', '#A1887F'
];

export const PieChartComponent = ({ data }) => {
 const processedData = processChartData(data);
 
 // Transform data for stacked chart
 const stackedData = [
   {
     name: 'Categories',
     // Create an entry for each category to be stacked
     ...processedData.reduce((acc, item, index) => {
       acc[`value${index}`] = item.value;
       return acc;
     }, {})
   }
 ];

 return (
   <div>
     <BarChart
       width={400}
       height={80}
       data={stackedData}
       layout="vertical"
       margin={{ top: 30, right: 100, left: 10, bottom: 10 }}
     >
       <XAxis type="number" hide domain={[0, 100]} />
       <YAxis type="category" hide dataKey="name" />
       
       {processedData.map((entry, index) => (
         <Bar
           key={`bar-${index}`}
           dataKey={`value${index}`}
           stackId="stack"
           fill={COLORS[index % COLORS.length]}
           barSize={30}
           radius={index === processedData.length - 1 ? [0, 6, 6, 0] : [0, 0, 0, 0]}
         >
           <LabelList
             dataKey={`value${index}`}
             position="center"
             formatter={(value) => value > 5 ? `${Math.round(value)}%` : ''}
             style={{ fill: "white", fontSize: "0.6rem" }}
           />
         </Bar>
       ))}
     </BarChart>
       {/* Legend below the chart */}
       <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        justifyContent: 'left',
        marginTop: '10px' 
      }}>
        {processedData.map((item, index) => (
          <div key={`legend-${index}`} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginRight: '15px',
            marginBottom: '5px'
          }}>
            <div style={{ 
              width: '10px', 
              height: '10px', 
              borderRadius: '50%', 
              backgroundColor: COLORS[index % COLORS.length],
              marginRight: '5px' 
            }} />
            <span style={{ fontSize: '0.7rem', color: 'white' }}>
            {`${item.label}: ${Math.round(item.value)}%`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};